<template>
  <div class="ma-2">
    <v-card-title>
       {{ audio.description }}
    </v-card-title>

    <v-divider/>
    <v-row dense>
      <v-col cols="5" v-show="dataRotas" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataRotas"
          :items-per-page.sync="itemsPerPage"
          :page="pageRoutes"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="routesHeaders"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Rotas:
                  {{ dataRotas ? dataRotas.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageRoutes"
                  :numberOfPages="numberOfPagesRoutes"
                  @firstPage="firstPageRoutes"
                  @formerPage="formerPageRoutes"
                  @nextPage="nextPageRoutes"
                  @lastPage="lastPageRoutes"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>  

     <v-col cols="5" v-show="dataUras" class="mr-4">
       <v-data-iterator
          :no-data-text="noDataText"
          :items="dataUras"
          :items-per-page.sync="itemsPerPage"
          :page="pageUras"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
          <v-data-table
            :headers="urasHeader"
            :items="props.items"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1"
          >
          </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Uras:
                  {{ dataUras ? dataUras.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageUras"
                  :numberOfPages="numberOfPagesUras"
                  @firstPage="firstPageUras"
                  @formerPage="formerPageUras"
                  @nextPage="nextPageUras"
                  @lastPage="lastPageUras"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>  
    <v-row dense>
      <v-col cols="5" v-show="dataResearchs" class="mr-4">
       <v-data-iterator
          :no-data-text="noDataText"
          :items="dataResearchs"
          :items-per-page.sync="itemsPerPage"
          :page="pageResearchs"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
          <v-data-table
            :headers="researchHeader"
            :items="props.items"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1"
          >
          </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Pesquisas:
                  {{ dataResearchs ? dataResearchs.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageResearchs"
                  :numberOfPages="numberOfPagesResearchs"
                  @firstPage="firstPageResearchs"
                  @formerPage="formerPageResearchs"
                  @nextPage="nextPageResearchs"
                  @lastPage="lastPageResearchs"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col> 
      <v-col cols="5" v-show="dataQueues">
       <v-data-iterator
          :no-data-text="noDataText"
          :items="dataQueues"
          :items-per-page.sync="itemsPerPage"
          :page="pageQueues"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
          <v-data-table
            :headers="queuesHeader"
            :items="props.items"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1"
          >
          </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Filas:
                  {{ dataQueues ? dataQueues.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageQueues"
                  :numberOfPages="numberOfPagesQueues"
                  @firstPage="firstPageQueues"
                  @formerPage="formerPageQueues"
                  @nextPage="nextPageQueues"
                  @lastPage="lastPageQueues"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col> 
    </v-row>
      
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import ListPagination from '@/componentes/ListPagination'
import audiosStore from '../_store'

export default {
  components: { ListPagination },
  name: 'Dialog',
  props: {
    audio: Object,
  },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    routesHeaders: [
        {
          text: 'Rota',
          value: 'route',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Ação',
          value: 'action',
          align: 'left',
        },
    ],
    urasHeader: [
        {
          text: 'Uras',
          value: 'ura',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Local',
          value: 'localUse',
          align: 'left',
        },
    ],
    researchHeader: [
        {
          text: 'Pesquisas',
          value: 'research',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Local',
          value: 'localUse',
          align: 'left',
        },
    ],
    queuesHeader: [
        {
          text: 'Filas',
          value: 'queue',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Local',
          value: 'localUse',
          align: 'left',
        },
    ],
    itemsPerPage: 5,
    pageRoutes: 1,
    pageUras: 1,
    pageResearchs: 1,
    pageQueues:1,
    dataRotas: [],
    dataUras: [],
    dataResearchs: [],
    dataQueues: [],
  }),
  async created() {
    registerVuexModule(this.$store, 'audiosHomeModulePABXStore', audiosStore)
  },
  computed: {
    ...mapGetters('audiosHomeModulePABXStore', ['getAudioUse']),
    numberOfPagesRoutes() {
      if(this.dataRotas){
       return Math.ceil(this.dataRotas.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesUras() {
      if(this.dataUras){
       return Math.ceil(this.dataUras.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesResearchs() {
      if(this.dataResearchs){
       return Math.ceil(this.dataResearchs.length / this.itemsPerPage)
      }
      return 0;
    },
    numberOfPagesQueues() {
      if(this.dataQueues){
       return Math.ceil(this.dataQueues.length / this.itemsPerPage)
      }
      return 0;
    },
  },
  methods: {
     firstPageRoutes() {
      if (this.pageRoutes > 1) {
        this.pageRoutes = 1
      }
    },
    formerPageRoutes() {
      if (this.pageRoutes > 1) {
        this.pageRoutes -= 1
      }
    },
    nextPageRoutes() {
      if (this.pageRoutes < this.numberOfPagesRoutes) {
        this.pageRoutes += 1
      }
    },
    lastPageRoutes() {
      if (this.pageRoutes < this.numberOfPagesRoutes) {
        this.pageRoutes = this.numberOfPagesRoutes
      }
    },
    firstPageUras() {
      if (this.pageUras > 1) {
        this.pageUras = 1
      }
    },
    formerPageUras() {
      if (this.pageUras > 1) {
        this.pageUras -= 1
      }
    },
    nextPageUras() {
      if (this.pageUras < this.numberOfPagesUras) {
        this.pageUras += 1
      }
    },
    lastPageUras() {
      if (this.pageUras < this.numberOfPagesUras) {
        this.pageUras = this.numberOfPagesUras
      }
    },
    firstPageResearchs() {
      if (this.pageResearchs > 1) {
        this.pageResearchs = 1
      }
    },
    formerPageResearchs() {
      if (this.pageResearchs > 1) {
        this.pageResearchs -= 1
      }
    },
    nextPageResearchs() {
      if (this.pageResearchs < this.numberOfPagesResearchs) {
        this.pageResearchs += 1
      }
    },
    lastPageResearchs() {
      if (this.pageResearchs < this.numberOfPagesResearchs) {
        this.pageResearchs = this.numberOfPagesResearchs
      }
    },
    firstPageQueues() {
      if (this.pageQueues > 1) {
        this.pageQueues = 1
      }
    },
    formerPageQueues() {
      if (this.pageQueues > 1) {
        this.pageQueues -= 1
      }
    },
    nextPageQueues() {
      if (this.pageQueues < this.numberOfPagesQueues) {
        this.pageQueues += 1
      }
    },
    lastPageQueues() {
      if (this.pageQueues < this.numberOfPagesQueues) {
        this.pageQueues = this.numberOfPagesQueues
      }
    },
  },
  watch: {
    getFilaUse: {
      deep: true,
      immediate: true,
      handler() {
        this.dataRotas = this.getAudioUse.routes
        this.dataUras = this.getAudioUse.uras
        this.dataResearchs = this.getAudioUse.researchs
        this.dataQueues = this.getAudioUse.queues
      },
    },
  },
}
</script>